module.exports = __webpack_public_path__ + "static/media/Workday_Step1b_Image4q.91fa3f56.jpg";